angular.module('storefrontApp')
    .component('vcCheckoutEmail', {
        templateUrl: 'themes/assets/js/checkout/checkout-email.tpl.html',
        bindings: {
            validationContainer: '=',
            email: '=',
        },
        controller: [function () {
            const ctrl = this;

            this.$onInit = function () {
                if (ctrl.validationContainer) {
                    ctrl.validationContainer.addComponent(this);
                }
            };

            this.$onDestroy = function () {
                if (ctrl.validationContainer) {
                    ctrl.validationContainer.removeComponent(this);
                }
            };

            ctrl.validate = function () {
                ctrl.form.$setSubmitted();
                return ctrl.form.$valid;
            };
        }],
    });
